export default __webpack_public_path__ + "static/media/img-0576-iceland-full-face.ea3843e1.png";